import { FC, useCallback, useMemo, useState } from 'react';
import { EIcon } from 'src/styles/theme/components/NGIcon/NGIcon.enum';
import { ESize } from 'src/styles/theme/utils/enums';
import { EActivateOn, ERhombusType } from './NGRhombus.enum';
import { StyledCrossContainer, StyledIcon, StyledRhombus, StyledWave } from './NGRhombus.styles';
import { INGRhombus } from './NGRhombus.type';

const NGRhombus: FC<INGRhombus> = ({
	size = ESize.s,
	type = ERhombusType.full,
	pulse = EActivateOn.never,
	clickAction = null,
	icon = EIcon.none,
	showMoreButton = false,
	isSelected = false,
	disabled = false,
	...otherProps
}) => {
	const [pulsing, setIsPulsing] = useState(false);

	const startAnimation = useCallback(() => {
		setIsPulsing(true);

		setTimeout(() => {
			setIsPulsing(false);
		}, 1250);
	}, []);

	const pulseOnHover = useMemo((): boolean => {
		return pulse === EActivateOn.hover || pulse === EActivateOn.both;
	}, [pulse]);

	const pulseOnClick = useMemo((): boolean => {
		return pulse === EActivateOn.click || pulse === EActivateOn.both;
	}, [pulse]);

	const onClickAction = useCallback(() => {
		if (clickAction) {
			clickAction();

			!pulsing && pulseOnClick && startAnimation();
		} else if (!pulsing && pulseOnClick) {
			startAnimation();
		}
	}, [clickAction, pulseOnClick, pulsing, startAnimation]);

	return (
		<StyledRhombus
			as={clickAction || pulseOnClick || showMoreButton ? 'button' : 'div'}
			size={size}
			type={!showMoreButton ? type : isSelected ? ERhombusType.full : ERhombusType.empty}
			onMouseEnter={!pulsing && pulseOnHover ? startAnimation : () => {}}
			onClick={onClickAction}
			icon={icon}
			isSelected={isSelected}
			showMoreButton={showMoreButton}
			disabled={disabled}
			{...otherProps}
		>
			{[1, 2].map((value) => (
				<StyledWave key={value} className={`wave-${value} ${pulsing ? 'running' : ''}`} />
			))}

			<div>
				<div>
					<StyledIcon size={size} disabled={disabled}>
						<i className={`icon-${icon}`} />
					</StyledIcon>
				</div>
			</div>

			{showMoreButton && (
				<StyledCrossContainer isSelected={isSelected}>
					<span />
					<span />
				</StyledCrossContainer>
			)}
		</StyledRhombus>
	);
};

export { NGRhombus };
